<template>
  <v-row>
    <v-col>
      <v-dialog ref="dateMenu"
                v-model="showDatePicker"
                persistent
                :return-value="date"
                width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field outlined
                        :append-icon="(readonly || disabled) ? null: 'fas fa-calendar-day'"
                        :value="date"
                        readonly
                        :hide-details="hideDetails"
                        v-on="(readonly || disabled) ? null : on"
                        :rules="rules"
                        :disabled="disabled"></v-text-field>
        </template>
        <v-date-picker v-model="date"
                       scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="showDatePicker = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.dateMenu.save(date)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-col>
    <v-col>
      <v-dialog ref="timeMenu"
                v-model="showTimePicker"
                persistent
                :return-value="time"
                width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field outlined
                        :append-icon="(readonly || disabled) ? null: 'fas fa-clock'"
                        :value="time"
                        readonly
                        :hide-details="hideDetails"
                        v-on="(readonly || disabled) ? null : on"
                        :rules="rules"
                        :disabled="disabled"></v-text-field>
        </template>
        <v-time-picker v-model="time"
                       scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="showTimePicker = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.timeMenu.save(time)">OK</v-btn>
        </v-time-picker>
      </v-dialog>
    </v-col>
  </v-row>

</template>

<script>
import {ref, watch} from "@vue/composition-api";
import {DateTime} from "luxon";

export default {
  name: 'DateTimePickerInput',
  props: {
    value: String,
    disabled: Boolean,
    readonly: Boolean,
    hideDetails: [Boolean, String],
    rules: Array,
  },
  setup(props, {root, emit}) {
    const date = ref(null);
    const clearDate = function () {
      date.value = (props.range ? [] : null);
      showDatePicker.value = false;
    };
    watch(
        date,
        (newVal, oldVal) => {
          if (newVal !== oldVal) {
            tryEmit();
          }
        }
    );

    const showDatePicker = ref(false);

    const time = ref(null);
    const clearTime = function () {
      time.value = (props.range ? [] : null);
      showTimePicker.value = false;
    };
    watch(
        time,
        (newVal, oldVal) => {
          if (newVal !== oldVal) {
            tryEmit();
          }
        }
    );

    const showTimePicker = ref(false);

    const tryEmit = function () {
      let datetime = DateTime.fromISO(date.value + 'T' + time.value);

      if (!datetime.invalid) {
        emit('input', datetime.toISO());
      }
    }

    watch(() => props.value, (newValue) => {
      if (newValue) {
        let datetime = DateTime.fromISO(newValue);
        if (!datetime.invalid) {
          date.value = datetime.toFormat('yyyy-MM-dd');
          time.value = datetime.toFormat('HH:mm');
        }

      } else {
        date.value = null;
        time.value = null;
      }
    }, {deep: true, immediate: true});

    return {
      date,
      showDatePicker,
      clearDate,

      time,
      showTimePicker,
      clearTime,
    }
  }
}
</script>
